module.exports = __webpack_public_path__ + "fonts/PRmiXeptR36kaC0GEAetxmdsm03krrxlabhmVQFB99s.woff2";